import { HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { finalize } from 'rxjs/operators';
import { SpinnerService } from '../services/spinner.service';
import { environment } from '../../environments/environment';

// Define URL patterns that should show the spinner
const ALLOWED_URL_PATTERNS = [
  `${environment.api.serverUrl}/hospital*`,
  `${environment.api.serverUrl}/data-set*`,
  `${environment.api.serverUrl}/admin*`,
];

export const spinnerInterceptor: HttpInterceptorFn = (req, next) => {
  const spinnerService = inject(SpinnerService);

  const showSpinner = shouldShowSpinner(req.url);

  if (showSpinner) {
    spinnerService.show();
  }

  return next(req).pipe(
    finalize(() => {
      if (showSpinner) {
        spinnerService.hide();
      }
    }),
  );
};

function shouldShowSpinner(url: string): boolean {
  return ALLOWED_URL_PATTERNS.some((pattern) => matchUrlPattern(url, pattern));
}

function matchUrlPattern(url: string, pattern: string): boolean {
  // Extract the path from the full URL (remove query params and hash)
  const urlPath = url.split('?')[0].split('#')[0];

  if (pattern === urlPath) {
    return true;
  }

  // If the pattern ends with an asterisk, check if the url starts with the pattern
  return (
    pattern.endsWith('*') &&
    urlPath.startsWith(pattern.slice(0, pattern.length - 1))
  );
}
